<template>
  <div class="col-12 col-md-12 col-lg-8 text-center" v-if="this.IdOportunidade!= 0">
    <!--Frame robinacademia -->
     <iframe :src="'https://robinacademia.com/p.ashx?o=90&e=1&t='+this.IdOportunidade" height="1" width="1" frameborder="0"></iframe>
    <!--Frame robinacademia -->
    <div class="tit">
      <img src="/static/assets/images/ico-smile.svg" alt="Icone feliz">
      <h1>Cadastro Concluído com sucesso!</h1>
      <p>Recebemos sua solicitação de empréstimo com sucesso.<br/>Em até <b>72 horas úteis</b>, você receberá uma resposta.<br/>Você poderá acompanhar a sua solicitação de empréstimo pela área do cliente ou por e-mail</p>
    </div>
    <div class="text-center">
      <a href="/" class="link" title="IOUU">
        <i class="ico-iouu" />
      </a>
      <p class="nome">Obrigado por escolher nos escolher!</p>
      <p class="obs">Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../assets/styles/iouu/variables";
  @import "../../assets/styles/iouu/mixins";

  div > {
    i {
      margin-top: 50px;
      font-size: 100px;
      line-height: 60px;
      color: $c3;
    }
  }
  .tit {
    img {
      width: 80px;
      margin-bottom: 40px
    }
  }
</style>

<script>
/* eslint-disable */
import ApiClient from "@/utils/api-client";
export default {
  date()
  {
    return {
      solicitacaoId : 0,
      IdOportunidade : 0
    }
  },
   created() {
    sessionStorage.removeItem("redirectINV");
   
    this.solicitacaoId = this.$route.params.id
     
    ApiClient.getLoanRequest(this.solicitacaoId)
      .then(loanRequest => {
        this.IdOportunidade  = loanRequest.IdOportunidade;
      }
    );
  }     
}
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/FinishedStep.vue